$(function () {
    console.log('tabbed group loading');

    // Hide elements on load
    $('.tabbed-group').addClass('tabbed-group-inactive');

    // Show first group
    $('.tabbed-group').eq(0).removeClass('tabbed-group-inactive');
    $('.tabbed-group').eq(0).addClass('tabbed-group-active');

    // Attach click events
    $('.tabbed-button').on('click', function () {
        $('.tabbed-button').removeClass('cta-active');
        $(this).addClass('cta-active');

        if ($(this).hasClass('tabbed-group-cta-general')) {
            $('.tabbed-group').removeClass('tabbed-group-active');
            $('.tabbed-group').addClass('tabbed-group-inactive');
            $('.tabbed-group-general').addClass('tabbed-group-active');
            $('.tabbed-group-general').removeClass('tabbed-group-inactive');
        }

        if ($(this).hasClass('tabbed-group-cta-eneloop')) {
            $('.tabbed-group').removeClass('tabbed-group-active');
            $('.tabbed-group').addClass('tabbed-group-inactive');
            $('.tabbed-group-eneloop').addClass('tabbed-group-active');
            $('.tabbed-group-eneloop').removeClass('tabbed-group-inactive');
        }        
    });
});